import { createFileRoute, Outlet } from '@tanstack/react-router'
import AppBar from '../../../shared/components/app-bar';
import PacificoIcon from '../../../shared/components/icons/PacificoIcon';


export const Route = createFileRoute('/_with-appbar/documents/')({

  component: ()=>{
    return<>
       <AppBar logo={<PacificoIcon />} />
       <Outlet />
    </>
  }
})
